import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgClipIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M55.481 8.404a14.7 14.7 0 0 1 0 21.208L27.366 56.868c-4.304 4.176-11.32 4.176-15.623 0-4.278-4.15-4.278-10.958 0-15.134l28.116-27.282c2.556-2.48 6.807-2.48 9.363 0 2.582 2.506 2.582 6.606 0 9.086L24.236 47.783c-.809.81-2.321.835-3.13.025-.835-.81-.835-2.252.026-3.062l24.96-24.22c.913-.886.913-2.176 0-3.037-.887-.86-2.217-.86-3.104 0L14.873 44.746c-2.608 2.556-2.608 6.554 0 9.11 2.634 2.531 6.755 2.531 9.363 0l28.116-27.281c4.355-4.227 4.355-10.933 0-15.16a11.21 11.21 0 0 0-15.623 0L11.743 35.66c-.809.81-2.321.835-3.13.026-.835-.81-.808-2.253.026-3.038L33.625 8.404c6.025-5.872 15.832-5.872 21.856 0"
    />
  </svg>
)
export default SvgClipIcon
